/*
 * @Author: Raeesaa Metkari
 * @Date: 2020-09-09 16:55:33
 * @Last Modified by: Raeesaa Metkari
 * @Last Modified time: 2020-09-11 21:23:15
 */

export enum ReportingTab {
  worldwide = 'worldwide',
  client = 'client',
  worldwideBuy = 'worldwideBuy',
  zoneBuy = 'zoneBuy',
  forecast = 'forecast'
}

export enum ReportingTabLabel {
  worldwide = 'Worldwide',
  client = 'Client',
  worldwideBuy = 'Worldwide Buy',
  zoneBuy = 'Zone Buy',
  forecast = 'Forecast'
}
